import { persistEventsToCache } from "applesauce-core/helpers";
import { Filter, NostrEvent } from "nostr-tools";
import { Observable } from "rxjs";
import { eventStore } from "./stores";

export function cacheRequest(filters: Filter[]) {
  return new Observable<NostrEvent>((observer) => {
    window.nostrdb
      .query(filters)
      .then((events) => {
        for (const event of events) observer.next(event);
        observer.complete();
      })
      .catch((error) => observer.error(error));
  });
}

// Save all new events to the cache
persistEventsToCache(eventStore, async (events) => {
  await Promise.allSettled(events.map((event) => window.nostrdb.add(event)));
});
